<template>
    <aside class="sidebar">
        <div class="sidebar-title">Disciplinas</div>
        <ul class="discipline-list">
            <li 
                v-for="disc in disciplines" 
                :key="disc.codigo_disciplina"
                :class="['discipline-item', { active: activeDiscipline === disc.codigo_disciplina }]"
                @click="$emit('select', disc.codigo_disciplina)"
            >
                <div class="discipline-content">
                    <div class="discipline-name">
                        <i class="fas fa-book"></i>
                        <span>{{ disc.nome_disciplina }}</span>
                    </div>
                    <div class="progress-bar-container" v-if="progressData && progressData[disc.codigo_disciplina] !== undefined">
                        <div class="progress-bar-fill" :style="{ width: progressData[disc.codigo_disciplina] + '%' }"></div>
                    </div>
                </div>
            </li>
        </ul>
    </aside>
</template>

<script>
export default {
    name: 'EmbedSidebar',
    props: {
        disciplines: {
            type: Array,
            required: true
        },
        activeDiscipline: {
            type: [String, Number],
            default: null
        },
        progressData: {
            type: Object,
            default: () => ({})
        }
    }
}
</script>

<style scoped src="./EmbedSidebar.css" />
